import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { IApiresponse } from "src/app/_models/common/request-response/apiresponse";
import { IApiRequest } from "src/app/_models/common/request-response/api-request";
import { ClaimsHeaderService } from "src/app/shared/claimsHeader/claims-header.service";
import { KeyValueArray, Wizard, WizardDetailRequest, WizardResponse } from "src/app/_models/common/wizard";
import { TranslateService } from "@ngx-translate/core";
import { map } from "rxjs/operators";

@Injectable({
    providedIn: "root",
})
export class WizardService {
    httpHeaders: HttpHeaders;
    constructor(
        private http: HttpClient,
        private claimsHeaderService: ClaimsHeaderService,
        private translate: TranslateService,
    ) { }

    GetWizardDetails(requestinfo: IApiRequest<WizardDetailRequest>): Observable<WizardResponse> {
      let body = JSON.stringify(requestinfo);
      let result: IApiresponse<WizardResponse>;
      return this.http
        .post<IApiresponse<WizardResponse>>(`${environment.billingApiUrl}GetWizardDetails`,body,
          { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
        )
        .pipe(
          map((result) => {
            result.responseInfo.wizardList = this.mapwizard(result.responseInfo.wizardList);
            result = result;
            return result.responseInfo;
          })
        );
    }

    mapwizard(wizardData): Wizard[] {
      const result: Wizard[] = [];
      wizardData.forEach((row) => {
        if (row) {
          result.push({
            iconClass: row.iconClass,
            iconPlacement: row.iconPlacement,
            iconTooltip: row.iconTooltip !=null ? this.translate.instant(row.iconTooltip) : null,
            isStepMandatory: row.isStepMandatory,
            progressbarMessage: this.fnGetKeyValueReplaceString(
              row.progressbarMessageArray,
              row.progressbarMessage
            ),
            progressbarMessageArray: row.progressbarMessageArray,
            progressbarType: row.progressbarType !=null ? row.progressbarType : null,
            progressbarValue: row.progressbarValue,
            stepClass: row.stepClass,
            stepDesc:row.stepDesc !=null ? this.translate.instant(row.stepDesc): null,
            stepDescMessage: this.fnGetKeyValueReplaceString(
              row.stepDescMessageArray,
              row.stepDescMessage
            ),
            stepDescMessageArray: row.stepDescMessageArray,
            stepExtraMessage: this.fnGetKeyValueReplaceString(
              row.stepExtraMessageArray,
              row.stepExtraMessage
            ),
            stepExtraMessageArray: row.stepExtraMessageArray,
            stepName: this.translate.instant(row.stepName),
            stepNum: row.stepNum,
            alertPanelType: row.alertPanelType,
            functionId: row.functionId,
            highlightStep: row.highlightStep,
            isDisabled: row.isDisabled,
            isInfoIcon: row.isInfoIcon,
            infoIconMsg: row.infoIconMsg,
            stepUrl: row.stepUrl,
            disabledClass: row.disabledClass,
            isProgressBar: row.isProgressBar,
            comingSoonDesc: this.translate.instant(row.comingSoonDesc),
            actualStepNum: row.stepNum,
            status: row.status,
            videoUrl: row.videoUrl,
            isActive: row.isActive,
            focusVisible: row.focusVisible,
            stats: row.stats ?? [],
            stats_two: row.stats_two ?? [],
            stats_three: row.stats_three ?? []

          });
        }
      });
      return result;
    }

    fnGetKeyValueReplaceString(keyValueArray: KeyValueArray[], text: string) {
      if (keyValueArray) {
        for (let index = 0; index < keyValueArray.length; index++) {
          let replacer = "##" + index + "##";
          text = text.replace(
            replacer,
            this.translate.instant(keyValueArray[index].value)
          );
        }
        return text;
      }
    }
}


